import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import { microsoftAuthApiRef, createFrontendModule } from '@backstage/frontend-plugin-api';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import bitbucketManagementPlugin from '@internal/plugin-bitbucket-management';
import defectDojoPlugin from '@internal/plugin-defectdojo';
import engineeringMetricsPlugin from '@internal/plugin-engineering-metrics';
import { maintainersModule } from './modules/maintainers';
import { techInsightsMaturityCompatPlugin } from './modules/tech-insights-maturity';
import { SignInPageBlueprint } from "@backstage/plugin-app-react";
import { SignInPage } from "@backstage/core-components";
import { catalogGraphModule } from './modules/catalog-graph';
import { usersModule } from './modules/users';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import linguistPlugin from '@backstage-community/plugin-linguist/alpha';
import { techInsightsModule } from './modules/tech-insights';
import { argoCDCompatPlugin } from './modules/argocd';
import { catalogColumnsModule } from './modules/catalog';
import toolboxPlugin from '@drodil/backstage-plugin-toolbox';
import { scaffolderModule } from './modules/scaffolder';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
// Loader bundling the contrib TechDocs addons (expandable navigation, report
// issue, text size, lightbox) as frontend modules of the TechDocs plugin.
import techdocsAddonsContrib from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import { toolboxModule } from './modules/toolbox';
import { techdocsModule } from './modules/techdocs';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      if (configApi.getString('auth.environment') === 'development') {
        return (
          <SignInPage
            {...props}
            providers={[
              'guest'
            ]}
          />
        );
      }
      return (<SignInPage
        {...props}
        providers={[
          {
            id: 'microsoft-auth-provider',
            title: 'Microsoft',
            message: 'Sign in using Microsoft',
            apiRef: microsoftAuthApiRef,
          },
        ]}
      />);
    },
  },
});

export default createApp({
  features: [
    argoCDCompatPlugin,
    bitbucketManagementPlugin,
    catalogPlugin,
    catalogColumnsModule,
    catalogGraphModule,
    defectDojoPlugin,
    engineeringMetricsPlugin,
    linguistPlugin,
    maintainersModule,
    navModule,
    homeModule,
    scaffolderModule,
    techInsightsMaturityCompatPlugin,
    techInsightsPlugin,
    techInsightsModule,
    techdocsPlugin,
    techdocsAddonsContrib,
    techdocsModule,
    toolboxPlugin,
    toolboxModule,
    usersModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
